<!--<template>-->
<!--  <div class="e-stepper-dots">-->
<!--  </div>-->
<!--</template>-->

<script>
export default {
  name: 'EStepperDots',
  props: {
    steps: {
      type: Number,
      default: 0,
      validator: (val) => val % 1 === 0,
    },
    totalVisible: [Number, String],
    value: {
      type: Number,
      default: 0,
    },
  },

  data() {
    return {
      maxButtons: 0,
      selected: null,
    }
  },

  computed: {
    classes() {
      return {
        'e-stepper-dots--inner': true,
      }
    },

    items() {
      const maxLength = this.steps

      if (this.steps <= maxLength) {
        return this.range(1, this.steps)
      }

      const even = maxLength % 2 === 0 ? 1 : 0
      const left = Math.floor(maxLength / 2)
      const right = this.steps - left + 1 + even

      if (this.value > left && this.value < right) {
        const firstItem = 1
        const lastItem = this.steps
        const start = this.value - left + 2
        const end = this.value + left - 2 - even
        const secondItem = start - 1 === firstItem + 1 ? 2 : '...'
        const beforeLastItem = end + 1 === lastItem - 1 ? end + 1 : '...'
        return [1, secondItem, ...this.range(start, end), beforeLastItem, this.steps]
      } else if (this.value === left) {
        const end = this.value + left - 1 - even
        return [...this.range(1, end), '...', this.steps]
      } else if (this.value === right) {
        const start = this.value - left + 1
        return [1, '...', ...this.range(start, this.steps)]
      } else {
        return [...this.range(1, left), '...', ...this.range(right, this.steps)]
      }
    },
  },
  watch: {
    value() {
      this.init()
    },
  },

  beforeMount() {
    this.init()
  },

  methods: {
    init() {
      this.selected = null

      setTimeout(() => (this.selected = this.value), 100)
    },
    next(e) {
      e.preventDefault()
      this.$emit('input', this.value + 1)
      this.$emit('next')
    },

    previous(e) {
      e.preventDefault()
      this.$emit('input', this.value - 1)
      this.$emit('previous')
    },

    range(from, to) {
      const range = []
      from = from > 0 ? from : 1

      for (let i = from; i <= to; i++) {
        range.push(i)
      }

      return range
    },

    genItem(h, i) {
      const isCurrentPage = i === this.value
      return h(
        'button',
        {
          staticClass: 'e-stepper-dot',
          class: {
            'e-stepper-dot--active': i === this.value,
          },
          attrs: {
            type: 'button',
            'aria-current': isCurrentPage,
          },
          on: {
            click: () => this.$emit('input', i),
          },
        },
        []
      )
    },

    genItems(h) {
      return this.items.map((i, index) => {
        return h(
          'div',
          {
            key: index,
          },
          [this.genItem(h, i)]
        )
      })
    },

    genList(h, children) {
      return h(
        'div',
        {
          class: this.classes,
        },
        children
      )
    },
  },

  render(h) {
    const children = [this.genItems(h)]
    return h(
      'div',
      {
        attrs: {
          role: 'navigation',
        },
      },
      [this.genList(h, children)]
    )
  },
}
</script>
